import React , {useEffect} from 'react';
import { useLocation } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { makeStyles, withStyles } from '@mui/styles';
import {Grid, Box, Card, CardContent, CardHeader,
    Typography,Checkbox , Input,
    FormGroup , FormControlLabel , FormControl , FormLabel, ToggleButton, ToggleButtonGroup 
} from '@mui/material';
import ButtonUnstyled, { buttonUnstyledClasses } from '@mui/core/ButtonUnstyled';
import { styled } from '@mui/system';
import { useHistory } from "react-router-dom";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

const THEME = createTheme({
    typography: {
     "fontFamily": `"PromptMedium","PromptSemiBold", "PromptRegular","PromptBold"`
    },palette: {
        primary: {
          main: '#7f51f5',
        }
      },
 });

const useStyles = makeStyles({
    body : {
        marginTop: '-3%'
    },
    headerTitle : {
        fontWeight: 'bold',
    },
    appbar: {
        alignItems: 'center',
    },
    textColor: {
        fontSize: '18px',
        color: '#7F51F5'
    },
    size12 :{
        fontSize : '13px'
    },
    redText: {
        color: 'red',
        textAlign: 'center',
        fontSize: '14px'
    },
    iconSize: {
        position: 'absolute',
        paddingLeft: '10px',
        marginTop: '15px'
    }
});

const label = { inputProps: { 'aria-label': 'Checkbox' } };

const CustomButtonRoot = styled('button')(`
  background-color: #7F51F5;
  padding: 15px 50px;
  border-radius: 20px;
  color: #fff;
  font-weight: 600;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
  transition: all 200ms ease;
  cursor: pointer;
  box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 0 rgba(0, 127, 255, 0);
  border: none;

  &:hover {
    background-color: #7F51F5;
  }

  &.${buttonUnstyledClasses.active} {
    background-color: #7F51F5;
  }

  &.${buttonUnstyledClasses.focusVisible} {
    box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 5px rgba(0, 127, 255, 0.5);
    outline: none;
  }
`);

const CustomButtonRootBack = styled('button')(`
  background-color: #c7c7c7;
  padding: 15px 50px;
  border-radius: 20px;
  color: #fff;
  font-weight: 600;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 14px;
  transition: all 200ms ease;
  cursor: pointer;
  box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 0 rgba(0, 127, 255, 0);
  border: none;

  &:hover {
    background-color: #7F51F5;
  }

  &.${buttonUnstyledClasses.active} {
    background-color: #c7c7c7;
  }

  &.${buttonUnstyledClasses.focusVisible} {
    box-shadow: 0 4px 20px 0 rgba(61, 71, 82, 0.1), 0 0 0 5px rgba(0, 127, 255, 0.5);
    outline: none;
  }
`);

function CustomCloseBack(props) {
    return <ButtonUnstyled {...props} component={CustomButtonRootBack} />;
}  

function CustomButton(props) {
    return <ButtonUnstyled {...props} component={CustomButtonRoot} />;
}

function ScrollToTopOnMount() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
    return null;
  }

function SymptomsPage2() {
    const { t, i18n } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    var choiceData = "";

    const [state, setState] = React.useState({
        checkBox1: false,
        checkBox2: false,
        checkBox3: false,
        checkBox4: false,
        checkBox5: false});
    const [checkBox6, setCheckBox6] = React.useState(false)
    const [disabled, setDisabled] = React.useState(false);
    const [checkInput, setCheckInput] = React.useState (false);
    const [lang, setLang] = React.useState(localStorage.getItem('language'));
    
    const handleChange = (event) => {
        setState({
            ...state,
            [event.target.name]: event.target.checked,
        });
    };

    const handleChangeDisable = (event) => {
        setCheckBox6(event.target.checked);
        console.log("check box 6:", event.target.checked);
        if (event.target.checked){
            setState({
                checkBox1: false,
                checkBox2: false,
                checkBox3: false,
                checkBox4: false,
                checkBox5: false});
            setDisabled(true);
        }else {
            setDisabled(false);
        }
    }

    const handleChangeLanguage = (event) => {
        console.log("language change:" , event.target.value);
        setLang(event.target.value);
        localStorage.setItem('language', event.target.value);
        i18n.changeLanguage(localStorage.getItem("language"));
    };

    const { checkBox1, checkBox2, checkBox3, 
        checkBox4, checkBox5} = state;

    const routeChange = () =>{ 
        if (checkBox1){
            choiceData = choiceData + t('chestPain')+ ", ";
        }
        if (checkBox2){
            choiceData = choiceData + t('shortnessBreath') + ", ";
        }
        if (checkBox3){
            choiceData = choiceData + t('breathingDifficulty') + ", " ;
        }
        if (checkBox4){
            choiceData = choiceData + t('diarrheaWithDizziness') + ", ";
        }
        if (checkBox5){
            choiceData = choiceData  + "ไม่รู้รส ";
        }
        if (checkBox6){
            choiceData = choiceData + t('noneOftheAbove');
        }

        if(!checkBox1 && !checkBox2 && !checkBox3 && !checkBox4 && !checkBox5 && !checkBox6){
            setCheckInput(true);
        }else{
            localStorage.setItem("symptomsTwo", choiceData);
            console.log("choice data:", choiceData);
            let path = `/oxygenConcentration`; 
            history.push(path);
        }
    }

    return (
        <ThemeProvider theme={THEME}>
        <br/>
        <div className={classes.body}>
            <ScrollToTopOnMount/>
            <div style={{float : 'right', marginRight: '18px'}}>
                <ToggleButtonGroup
                    color="primary"
                    value={lang}
                    exclusive
                    onChange={handleChangeLanguage}
                    size="small"
                >
                    <ToggleButton value="en">English</ToggleButton>
                    <ToggleButton value="th">ภาษาไทย</ToggleButton>
                </ToggleButtonGroup>
            </div>
            <br/>

            <Box sx={{ flexGrow: 1 }} pt={3}>
                <Grid container pl={2} pr={2}>
                    
                    <Grid item  md={12} xs={12}>
                        <Card sx={{ minWidth: 275 }} variant="outlined" style={{borderRadius: '15px', borderColor: '#D2C4F8'}}>
                        <CardHeader
                            subheader={t('currentSymptoms2')}
                            subheaderTypographyProps={{color:'#fff', fontSize: '12px' }}
                            style={{ paddingLeft:'30px', backgroundColor: '#7F51F5',color: '#fff' }}

                        />
                            <CardContent>
                                <FormGroup style={{ paddingLeft: '13px' }}>
                                    <FormControl component="fieldset">
                                    <FormLabel component="legend" style={{color: 'black', fontSize: '13px'}}>
                                        {t('symptoms1Title')}
                                    </FormLabel>
                                    <br/>
                                        <FormControlLabel
                                            control={
                                            <Checkbox 
                                            {...label}
                                                sx={{
                                                color: "#7F51F5",
                                                '&.Mui-checked': {
                                                    color: "#7F51F5",
                                                },
                                                }}
                                            checked={checkBox1} onChange={handleChange} 
                                            disabled = {disabled}
                                            name="checkBox1" size="small"/>
                                            }
                                            label={<Typography style={{fontSize: '12px'}}> {t('chestPain')}</Typography>}/>
                                        
                                        <FormControlLabel
                                            control={
                                            <Checkbox 
                                            {...label}
                                            sx={{
                                            color: "#7F51F5",
                                            '&.Mui-checked': {
                                                color: "#7F51F5",
                                            },
                                            }}
                                            checked={checkBox2} onChange={handleChange} 
                                            disabled = {disabled}
                                            name="checkBox2" size="small" />
                                            }
                                            label={<Typography style={{fontSize: '12px'}}>{t('shortnessBreath')}</Typography>}/>
                                        <FormControlLabel
                                            control={
                                            <Checkbox
                                            {...label}
                                            sx={{
                                            color: "#7F51F5",
                                            '&.Mui-checked': {
                                                color: "#7F51F5",
                                            },
                                            }}
                                            checked={checkBox3} onChange={handleChange} 
                                            disabled = {disabled}
                                            name="checkBox3" size="small"/>
                                            }
                                            label={<Typography style={{fontSize: '12px'}}>{t('breathingDifficulty')}</Typography>}/>
                                        
                                        
                                        <FormControlLabel
                                            control={
                                            <Checkbox
                                            {...label}
                                            sx={{
                                            color: "#7F51F5",
                                            '&.Mui-checked': {
                                                color: "#7F51F5",
                                            },
                                            }}
                                            checked={checkBox4} onChange={handleChange} 
                                            disabled = {disabled}
                                            name="checkBox4" size="small"/>
                                            }
                                            label={<Typography style={{fontSize: '12px'}}>{t('diarrheaWithDizziness')}</Typography>}/>

                                        {/* <FormControlLabel
                                            control={
                                            <Checkbox
                                            {...label}
                                            sx={{
                                            color: "#7F51F5",
                                            '&.Mui-checked': {
                                                color: "#7F51F5",
                                            },
                                            }}
                                            checked={checkBox5} onChange={handleChange} 
                                            disabled = {disabled}
                                            name="checkBox5" size="small"/>
                                            }
                                            label={<Typography style={{fontSize: '12px'}}>{t('chestPain')} ไม่รู้รส</Typography>}/> */}
                                        
                                        <FormControlLabel
                                            control={
                                            <Checkbox
                                            {...label}
                                            sx={{
                                            color: "#7F51F5",
                                            '&.Mui-checked': {
                                                color: "#7F51F5",
                                            },
                                            }}
                                            checked={checkBox6} onChange={handleChangeDisable} name="checkBox6" size="small"/>
                                            }
                                            label={<Typography style={{fontSize: '12px'}}>{t('noneOftheAbove')}</Typography>}/>
                                        
                                    </FormControl>
                                </FormGroup>
                            </CardContent>
                        </Card>
                    </Grid>
                    
                </Grid>     
            </Box>

            {
                checkInput ? 
                    <><br/> <p className={classes.redText}>
                        <span className="font-face-pm">
                            {t('showRequiredChoice')}
                        </span>
                        </p>
                    </> 
                : <></>
            }

            <Box sx={{ flexGrow: 1 }} pt={3}>
            <Grid container pl={2} pr={2}>
                
                    <Grid item  md={6} xs={6} style={{float: 'left'}}>
                        <div>
                        <CustomCloseBack onClick={() => {history.goBack();}}>BACK</CustomCloseBack>
                        </div>
                    </Grid>
                    <Grid item  md={6} xs={6}>
                        <div style={{float: 'right'}}>
                            <CustomButton onClick={routeChange}>NEXT</CustomButton>
                        </div>
                    </Grid>
            </Grid>     
            </Box>

            <Box sx={{ flexGrow: 1 }} pt={3}>
                <Grid container pl={2} pr={2} direction="column">
                    
                        <Grid item  md={12} xs={12}>
                            <div className={classes.appbar} style={{fontSize: '11px', color: 'grey' , fontWeight: 'bold', float: 'right'}}>
                                { "Page |" + " 3/" + localStorage.getItem('totalPageDailyForm') }
                            </div>
                        </Grid>
                </Grid>     
            </Box>
            <br/> 
            <br/> 
            <br/> 
        </div>
    
        </ThemeProvider>

    )
}

export default SymptomsPage2
